import {PaymentInformation, PaymentItem} from '../ReserveFacilityModel'
import {Nullable} from '../../../app/TypeHelpers'
import {ReserveOptionPaymentCalculator} from './ReserveOptionPaymentCalculator'

export default abstract class ReservePaymentCalculator {
    protected readonly optionPaymentCalculator: Nullable<ReserveOptionPaymentCalculator>

    protected constructor(optionPaymentCalculator: Nullable<ReserveOptionPaymentCalculator>) {
        this.optionPaymentCalculator = optionPaymentCalculator
    }

    protected abstract calculateFacilityPayment(): PaymentItem

    abstract isEnableCalculate(): boolean

    calculate(): PaymentInformation {
        if (!this.isEnableCalculate()) {
            throw Error('you have to confirm calculate availability in advance.')
        }

        const facilityPayment: PaymentItem = this.calculateFacilityPayment()
        const optionPayment: PaymentItem[] = this.calculateOptionPayment()

        const facilityCharge: number = facilityPayment.charge || 0
        const optionCharge: number = (optionPayment.length === 0)
            ? 0
            : optionPayment
                .map(paymentInfo => paymentInfo.charge || 0)
                .reduce((accumulator, charge) => accumulator + charge)

        return {
            items: [facilityPayment, ...optionPayment],
            totalCharge: (facilityCharge + optionCharge),
        }
    }

    protected calculateOptionPayment(): PaymentItem[] {
        if (!this.optionPaymentCalculator) {
            throw Error('not initialized')
        }

        return this.optionPaymentCalculator.calculate()
    }
}
